import { render, staticRenderFns } from "./AppExit.vue?vue&type=template&id=90a37432&scoped=true&"
import script from "./AppExit.vue?vue&type=script&lang=js&"
export * from "./AppExit.vue?vue&type=script&lang=js&"
import style0 from "./AppExit.vue?vue&type=style&index=0&id=90a37432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a37432",
  null
  
)

export default component.exports